/* eslint-disable @next/next/no-img-element */
import cn from 'classnames'
import Link from 'next/link'
import { FC, useState } from 'react'
import { useRouter } from 'next/router'
import s from './I18nWidget.module.css'
import ClickOutside from '@lib/click-outside'
import { useTranslations } from 'next-intl'

interface LOCALE_DATA {
  name: string
  shortname: string
  img: {
    filename: string
    alt: string
  }
}

const LOCALES_MAP: Record<string, LOCALE_DATA> = {
  de: {
    name: 'German',
    shortname: 'DE',
    img: {
      filename: 'flag-de.svg',
      alt: 'German',
    },
  },
  'en': {
    name: 'English',
    shortname: 'EN',
    img: {
      filename: 'flag-en-us.svg',
      alt: 'US Flag',
    },
  },
}

const I18nWidget: FC = () => {
  const [display, setDisplay] = useState(false)
  const {
    locale,
    locales,
    defaultLocale = 'de',
    asPath: currentPath,
  } = useRouter()

  const options = locales?.filter((val) => val !== locale)
  const currentLocale = locale || defaultLocale
  const t = useTranslations('Global')

  return (
    <ClickOutside active={display} onClick={() => setDisplay(false)}>
      <nav className={s.root}>
        <div
          className="flex items-center relative"
          onClick={() => setDisplay(!display)}
        >
          <button className={s.button} aria-label="Language selector">
            <span className={s.icon + ' icon-32-GlobeSimple-32 text-primary100 text-icon22 mr-2'}></span>
            <span className={'text-paragraph01 font-light text-primary100'}>{LOCALES_MAP[currentLocale].shortname}</span>
          </button>
        </div>
        <div className="absolute top-16 left-0 langChooser">
          {options?.length && display ? (
            <div className={s.dropdownMenu + ' dropdownMenu'}>
              <ul>
                {options.map((locale) => (
                  <li key={locale}>
                    <Link
                      href={currentPath}
                      locale={locale}
                      className={cn(s.item) + ' item'}
                      onClick={() => setDisplay(false)}
                    >
                      {t(LOCALES_MAP[locale].shortname)}
                    </Link>
                  </li>
                ))}
                <li className={s.active + ' active'} key={currentLocale}>
                  <span className={s.item + ' item'}>{t(LOCALES_MAP[currentLocale].shortname)}</span>
                </li>
              </ul>
            </div>
          ) : null}
        </div>
      </nav>
    </ClickOutside>
  )
}

export default I18nWidget
